<template>
  <div>
    <b-popover
      target="footer1"
      custom-class="coming-soon"
      triggers="focus"
      placement="top"
    >
      <span class="bold">COMING SOON</span>
    </b-popover>
    <b-popover
      target="footer2"
      custom-class="coming-soon"
      triggers="focus"
      placement="top"
    >
      <span class="bold">COMING SOON</span>
    </b-popover>
    <b-popover
      target="footer3"
      custom-class="coming-soon"
      triggers="focus"
      placement="top"
    >
      <span class="bold">COMING SOON</span>
    </b-popover>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
